import { render } from "./MerchantListTable.vue?vue&type=template&id=22431eec&scoped=true&ts=true"
import script from "./MerchantListTable.vue?vue&type=script&lang=ts"
export * from "./MerchantListTable.vue?vue&type=script&lang=ts"

import "./MerchantListTable.vue?vue&type=style&index=0&id=22431eec&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22431eec"]])

export default __exports__